import React from 'react'

import Spinner from 'react-bootstrap/Spinner';

const Loading = ({txt, children, ...props}) => {
	return txt ? <span {...props}>{children||"Cargando..."}</span> : <Spinner animation="border" 
		variant="secondary" size="sm" role="status"  {...props}
	>
		{children}
		<span className="sr-only">Cargando...</span>
	</Spinner>
}

export default Loading
